import React, { FC } from 'react';
import * as MESSAGES from 'constants/messages';
import { ButtonM } from 'components/atoms';
import { Modal, ModalContent, ModalFooter } from 'components/molecules';

type UpdateProfileCompletedModalProps = {
  show: boolean;
  onClose: () => void;
};

const UpdateProfileCompletedModal: FC<UpdateProfileCompletedModalProps> = ({
  show,
  onClose,
}) => {
  return (
    <Modal show={show} closeModal={onClose}>
      <ModalContent>
        {MESSAGES.PROFILE_SETTING.MODAL.UPDATE_PROFILE_COMPLETED.CONTENT}
      </ModalContent>
      <ModalFooter>
        <ButtonM onClick={onClose}>{MESSAGES.COMMON.BUTTON.OK}</ButtonM>
      </ModalFooter>
    </Modal>
  );
};

export default UpdateProfileCompletedModal;
